import { PageProps } from 'gatsby';
import { DashboardLayout } from 'modules/dashboard';
import { ProposalOverviewSection } from 'modules/proposals-overview';
import React from 'react';
import { useIntl } from 'react-intl';
import { PageLoading, SEO } from 'shared/components';
import { useProposalsLoadingSelector } from '../state';

export const ProposalsOverview: React.FC<PageProps> = ({ location }) => {
  const { formatMessage } = useIntl();
  const loading = useProposalsLoadingSelector();

  if (loading) return <PageLoading isLoading={loading} />;

  return (
    <>
      <SEO
        title={formatMessage({ id: 'proposals.seo.title' })}
        description={formatMessage({ id: 'proposals.seo.description' })}
        href={location.href}
      />
      <DashboardLayout>
        <ProposalOverviewSection />
      </DashboardLayout>
    </>
  );
};
